/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AnalyzeSqlQueryRequest {
  /**
  * IDs of completed SQL query executions (EXPLAIN variants) to analyze
  */
  'sqlQueryExecutionIds': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sqlQueryExecutionIds",
      "baseName": "sqlQueryExecutionIds",
      "type": "Array<string>",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return AnalyzeSqlQueryRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

